import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';

import BrandPanel from './BrandPanel';
import CustomContent from './CustomContent';
import DesktopFooter from './DesktopFooter';
import styles from './index.module.scss';

const AppLayout = () => {
  const { isMobile } = usePlatform();

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        <div className={styles.formColumn}>
          <main className={classNames(styles.main, layoutClassNames.mainContent)}>
            <Outlet />
          </main>
          {!isMobile && <DesktopFooter />}
        </div>
        {!isMobile && <BrandPanel className={styles.brandPanel} />}
      </div>
    </div>
  );
};

export default AppLayout;
